// extracted by mini-css-extract-plugin
module.exports = {"recent_bookings_slider":"_1-axR"};